import React from 'react';
import includes from 'lodash/includes';
import compose from "recompose/compose";
import withProps from 'recompose/withProps';
import lifecycle from 'recompose/lifecycle';
import {connect} from "react-redux";
import {formatDate, pageCount, prependRecentIfFirstPage} from "utils/DBUtils";
import ImageCard from "components/images/ImageCard";
import ItemExplorer from "components/common/ItemExplorer";
import ImageEditModalContainer from "pages/Images/ImageEditModalContainer";
import {getOriginalsPageAction, startEditImageAction, toggleImagesPageViewAction} from './actions';
import UploadImageButton from "./UploadImageButton";
import * as ResourceApi from 'api/resources';
import {getResourcePageAction} from 'resources/actions';
import {createResourcePageSelector, createResourcePageItemsSelector} from 'resources/selectors';
import {createResourceSortOptionsSelector, createResourceNamedFiltersSelector} from 'viewOptions/selectors';
import {imagesFilterGroups} from './utils';
import {
    addFilterForResourceAction,
    removeFilterForResourceAction,
    removeAllFiltersForResourceAction,
    toggleSortForResourceAction
} from 'viewOptions/actions';

const getResourcePage = createResourcePageSelector(ResourceApi.Types.Image);
const getPageItems = createResourcePageItemsSelector(ResourceApi.Types.Image);
const getSortOptions = createResourceSortOptionsSelector(ResourceApi.Types.Image);
const getNamedFilters = createResourceNamedFiltersSelector(ResourceApi.Types.Image);

const mapStateToProps = (state) => {
    const page = getResourcePage(state.resources);
    console.log(page);

    const namedFilters = getNamedFilters(state);
    const hasNamedFilter = name => includes(namedFilters, name);

    const filterGroups = imagesFilterGroups;
    const canAddFilter = name => {
        const filterGroup = filterGroups.find(group => includes(group, name)) || [];
        const groupIsAlreadyActive = filterGroup.find(hasNamedFilter);
        return !groupIsAlreadyActive;
    };

    return {
        images: prependRecentIfFirstPage(
            page.page,
            page.count,
            state.images.recentUploads,
            getPageItems(state.resources)
        ),
        pageSize: state.images.currentPageSize,
        currentPage: page.page,
        totalImages: page.total,
        imagesPageSize: page.count,
        rowCount: state.images.rowCount,
        colCount: state.images.colCount,
        selectedView: state.images.selectedView,
        sortOptions: getSortOptions(state),
        filterGroups,
        namedFilters,
        hasNamedFilter,
        canAddFilter
    };
};

const mapDispatchToProps = {
    getOriginalsPage: page => getResourcePageAction(ResourceApi.Types.Image, 10, page),
    startEditImage: image => startEditImageAction(image),
    toggleView: () => toggleImagesPageViewAction,
    selectSort: field => toggleSortForResourceAction(ResourceApi.Types.Image, field),

    addFilter: name => addFilterForResourceAction(ResourceApi.Types.Image, name),
    onFilterDeselected: name => removeFilterForResourceAction(ResourceApi.Types.Image, name),
    clearAllFiltersWithSortOptions: sortOptions => removeAllFiltersForResourceAction(ResourceApi.Types.Image, sortOptions)
};

const ImagePageWithProps = withProps((ownerProps) => ({
    header: "Images",
    description: "Upload and manage images.",
    showView: ownerProps.selectedView,
    onViewToggled: ownerProps.toggleView,
    actions: [
        UploadImageButton
    ],
    filterBarProps: {
        hidden: false,
        namedFilters: ownerProps.namedFilters,
        filterGroups: ownerProps.filterGroups,
        hasNamedFilter: ownerProps.hasNamedFilter,
        onFilterSelected: name => {
            if (ownerProps.canAddFilter(name)) {
                ownerProps.addFilter(name);
            }
        },
        onFilterDeselected: ownerProps.onFilterDeselected,
        clearAllFilters: () => ownerProps.clearAllFiltersWithSortOptions(ownerProps.sortOptions)
    },
    pagingBarProps: {
        count: pageCount(ownerProps.totalImages, ownerProps.pageSize),
        total: ownerProps.totalImages,
        currentPage: ownerProps.currentPage,
        maxPages: 10,
        onPageSelected: (page) => ownerProps.getOriginalsPage(page),
        onNextClicked: (currentPage) => ownerProps.getOriginalsPage(currentPage+1),
        onPreviousClicked: (currentPage) => ownerProps.getOriginalsPage(currentPage-1)
    },
    gridProps: {
        items: ownerProps.images,
        colCount: ownerProps.colCount,
        rowCount: ownerProps.rowCount,
        cellFunc: (image) => <ImageCard {...image} />
    },
    tableProps: {
        items: ownerProps.images,
        onRowClicked: (item) => ownerProps.startEditImage(item.id),
        sortOptions: ownerProps.sortOptions,
        onSortClick: (details) => details.fieldName ? ownerProps.selectSort(details.fieldName) : null,
        colDetails: [
            {
                header: "Name",
                fieldName: "name",
                detailFunc: (image) => image.name || image.filename || "No Name",
                canSort: true
            },
            {
                header: "Created",
                fieldName: "_created",
                detailFunc: (image) => formatDate(image._created),
                canSort: true
            },
            {
                header: "Type",
                fieldName: "imageType",
                detailFunc: (image) => image.imageType,
                canSort: true,
            },
            {
                header: "Author",
                detailFunc: (image) => image.createdBy,
                canSort: false
            },
            {
                header: "Actions",
                detailFunc: (image) => "Select",
                canSort: false
            }
        ]
    }
}));

const ImagePageItemExplorer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    ImagePageWithProps,
    lifecycle({
        componentWillMount() {
            this.props.getOriginalsPage(1);
        }
    })
)(ItemExplorer);

const ImagePage = () => [
    <div className='list-images-page'><ImagePageItemExplorer key={"ImagePageItemExplorer"}/></div>,
    <ImageEditModalContainer key={"ImagePageModalContainer"}/>
];

export default ImagePage;



// WEBPACK FOOTER //
// ./public/pages/Images/ImagesPage.jsx